import z from 'zod';
import {epochTimestamp} from '../_other';

export const tradeMessageWriteSchema = z.object({
  note: z.string().default(''),
  screenshotStoragePath: z.string().min(1).optional(),
  createdAt: epochTimestamp.optional().default(Date.now()),
});

export interface TradeMessageWrite extends z.infer<typeof tradeMessageWriteSchema> {}
